import React from 'react';
import { useParams } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';
import logoLadoBom from '../../resources/imgs/logo-lado-bom-seguros.svg';
import { useStandaloneKyc } from './hooks/useStandaloneKyc';
import KycView from './components/KycView';
import CompletedView from './components/CompletedView';
import RejectedView from './components/RejectedView';
import {
  PageShell,
  TopBar,
  BrandLogo,
  MainCard,
  TitleRow,
  Subtitle,
  CenteredLoader,
  ErrorBox,
} from './styles';

const StandaloneKycPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const { loading, error, data, refetch } = useStandaloneKyc(token);

  return (
    <PageShell>
      <TopBar>
        <BrandLogo src={logoLadoBom} alt="Lado Bom Seguros" />
      </TopBar>

      {loading && (
        <MainCard>
          <CenteredLoader>
            <Loader active size="large" />
            Carregando biometria...
          </CenteredLoader>
        </MainCard>
      )}

      {!loading && error && <ErrorBox role="alert">{error}</ErrorBox>}

      {!loading && !error && data && (
        <MainCard>
          <TitleRow>Biometria Pagar.me</TitleRow>

          {data.recipientName && (
            <Subtitle>{data.recipientName}</Subtitle>
          )}

          {data.status === 'COMPLETED' ? (
            <CompletedView />
          ) : data.status === 'REJECTED' ? (
            <RejectedView />
          ) : (
            <KycView
              kycLinkUrl={data.kycLinkUrl}
              kycQrPayload={data.kycQrPayload}
              onRefresh={refetch}
            />
          )}
        </MainCard>
      )}
    </PageShell>
  );
};

export default StandaloneKycPage;
